export default __webpack_public_path__ + "static/media/chem820.52d1ae0d.svg";